import { lazy } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import useAuth from '../../../hooks/useAuth'

const LoggedInPage = lazy(() => import('../../pages/LoggedInPage'))

const RequireAuth: React.FC = () => {
  const isAuth = useAuth()
  const location = useLocation()

  if (isAuth) {
    // If user is authenticated and trying to access a specific path (not root),
    // let the LoggedInPage handle the routing
    return <LoggedInPage />
  }

  // Store the current location in state so we can redirect back after login
  return <Navigate to="/login" state={{ from: location }} replace />
}

export default RequireAuth
